import api from '../api'

const getDashboardData = ({ commit }) => {
  api
    .getDashboardData()
    .then(({ data }) => {
      commit('SET_EMERGENCY_ROOM_DASHBOARD_DATA', data)
    })
    .catch(error => {
      console.error(error)
    })
}

const getFirstEmergencyRoomItem = ({ commit }) => {
  api
    .getFirstEmergencyRoomItem()
    .then(({ data }) => {
      const item = {
        ...data,
        screening: data.screening ? JSON.parse(data.screening) : null
      }
      commit('SET_EMERGENCY_ROOM_FIRST_ITEM', item)
    })
    .catch(error => {
      console.error(error)
    })
}

const getEmergencyRoomItems = ({ commit, state }) => {
  const { page, query, status, priority } = state
  commit('SET_EMERGENCY_ROOM_LOADING', true)
  api
    .getEmergencyRoomItems(
      page,
      query,
      typeof status === 'string' ? status : status?.value,
      priority
    )
    .then(({ data }) => {
      const items = data.data.map(item => ({
        ...item,
        screening: item.screening ? JSON.parse(item.screening) : null
      }))
      commit('SET_EMERGENCY_ROOM_ITEMS', items)
      commit('SET_EMERGENCY_ROOM_TOTAL', data.total)
    })
    .catch(error => {
      console.error(error)
    })
    .finally(() => {
      commit('SET_EMERGENCY_ROOM_LOADING', false)
    })
}

const setQuery = ({ commit }, query) => {
  commit('SET_EMERGENCY_ROOM_QUERY', query)
}

const setStatus = ({ commit }, status) => {
  commit('SET_EMERGENCY_ROOM_STATUS', status)
}

const setPage = ({ commit }, page) => {
  commit('SET_EMERGENCY_ROOM_PAGE', page)
}

export default {
  getDashboardData,
  getFirstEmergencyRoomItem,
  getEmergencyRoomItems,
  setQuery,
  setStatus,
  setPage
}
